export const SET_USER_UNDERSTANDING = "@USER_UNDERSTANDING/SET_USER_UNDERSTANDING";
